import { all, call, fork, put, takeLatest } from "typed-redux-saga";
import { Action, faqActions } from "./faq-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { FaqCategoryService, Model_FaqCategoryGet } from "src/backend/openapi/v1";

export function* getFaqByLanguageId(action: ReturnType<typeof faqActions.getFaqRequestByLanguageId>) {
  try {
    const result: Model_FaqCategoryGet[] = yield call(FaqCategoryService.getApiV1FaqByLanguageId, action.payload.languageId);
    yield put(faqActions.getFaqSuccessByLanguageId(result, action.payload.languageId));
  } catch (error) {
    yield put(errorActions.addError(error));
  }
}

export function* watchGetFaqCategory() {
  yield takeLatest(Action.GetFaqRequestByLanguageId, getFaqByLanguageId);
}

export function* faqSaga() {
  yield all([fork(watchGetFaqCategory)]);
}
